import YLoading from './Loading';

export { YLoading };
export default YLoading;
